import { render, staticRenderFns } from "./WorkoutSvgContent.vue?vue&type=template&id=04756dae&scoped=true"
import script from "./WorkoutSvgContent.vue?vue&type=script&lang=js"
export * from "./WorkoutSvgContent.vue?vue&type=script&lang=js"
import style0 from "./WorkoutSvgContent.vue?vue&type=style&index=0&id=04756dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04756dae",
  null
  
)

export default component.exports